import { render, staticRenderFns } from "./AttributionTable.vue?vue&type=template&id=48a2de74&scoped=true"
import script from "./AttributionTable.vue?vue&type=script&lang=js"
export * from "./AttributionTable.vue?vue&type=script&lang=js"
import style0 from "./AttributionTable.vue?vue&type=style&index=0&id=48a2de74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a2de74",
  null
  
)

export default component.exports